// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 818 ? "runBigTaskWorker" : chunkId) + "." + {"57":"8520c1c3","315":"48b26fc0","495":"21e970e1","498":"ebf4806a","787":"c6006e9a","818":"136dbabc","936":"b49a7643"}[chunkId] + ".chunk.js";
};